import { Card, EmptyState } from '@ui/themed';

/** Full-screen error for a route that failed to render, in place of the loading screen. */
export function ErrorScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-spark-surface-page p-6">
      <div className="w-full max-w-lg">
        <Card>
          <EmptyState kind="error" onRetry={onRetry} />
        </Card>
      </div>
    </div>
  );
}
